// src/json/overlayData.json
export const overlaySectionBalconyRenewal = {
    imageUrl: "/assets/imgs/services/9BalconyRenewal/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
